module.exports = __webpack_public_path__ + "img/filter.601cd039.svg";